import urls from "../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../service";

export async function addPushNotification(payload:any) {
    console.log(payload,"payloadddddddddddddddd")

    try {
      const callParams = await getCallParams("POST",payload);
      const response = await makeCall(urls.ADDPUSHNOTIFICATION, callParams);
      console.log(response,"responseeeeeeeeeeeeee")
      return response;
    } catch (error) {
      throw error;
    }
  }
  export async function updatePushNotification(payload:any) {
    console.log(payload,"payloadddddddddddddddd")

    try {
      const callParams = await getCallParams("PUT",payload);
      const response = await makeCall(urls.UPDATEPUSHNOTIFICATION, callParams);
      console.log(response,"responseeeeeeeeeeeeee")
      return response;
    } catch (error) {
      throw error;
    }
  }
  export async function getNotification() {
    try {
      const callParams = await getCallParams("GET");
      const response = await makeCall(urls.GETNOTIFICATION, callParams);
      console.log(response)
  
      return response;
    } catch (error) {
      console.log("hh")
      throw error;
    }
  }
  export async function addNotificationToken(payload:any) {
    console.log(payload,"payloadddddddddddddddd")

    try {
      const callParams = await getCallParams("POST",payload);
      const response = await makeCall(urls.ADDNOTIFICATIONTOKEN, callParams);
      console.log(response,"responseeeeeeeeeeeeee")
      return response;
    } catch (error) {
      throw error;
    }
  }

  /** Clear FCM/device tokens for this user (call on logout). */
  export async function clearNotificationToken(payload?: {
    userId?: string;
    token?: string;
    source?: string;
  }) {
    try {
      const callParams = await getCallParams("POST", payload || {});
      return await makeCall(urls.CLEARNOTIFICATIONTOKEN, callParams);
    } catch (error) {
      // Best-effort — logout must still proceed
      console.warn("clearNotificationToken failed", error);
      return null;
    }
  }

  export async function getAllTodayReminders() {
    try {
      const callParams = await getCallParams("GET");
      const response = await makeCall(urls.GETTODAYREMINDERS, callParams);
      console.log(response)
  
      return response;
    } catch (error) {
      console.log("hh")
      throw error;
    }
  }

  export async function ackLeadReminder(reminderIds: string | string[]) {
    try {
      const ids = (Array.isArray(reminderIds) ? reminderIds : [reminderIds])
        .map((id) => String(id || "").trim())
        .filter(Boolean);
      if (!ids.length) return null;
      const callParams = await getCallParams("POST", { reminderIds: ids });
      return await makeCall(urls.ACKLEADREMINDER, callParams);
    } catch (error) {
      console.warn("ackLeadReminder failed", error);
      return null;
    }
  }